import {getFcp, getFmp} from '.';

const isProd = process.env.NODE_ENV === 'production';
const isTest = process.env.NODE_ENV === 'test';

const logger = (title: string, style: string | {[key: string]: any}, info = ''): void => {
  if (isProd) {// 生产环境
    return;
  }

  if (isTest && !window.location.href.includes('http://localhost')) {// 测试环境
    console.info(title, '>>>>>', info);
  }
  else if (typeof style === 'string') {// 本地开发环境
    console.log(`%c${title}`, `color: #fff; background: ${style};`, info);
  }
  else {
    const styleStr = Object
      .entries(style)
      .map(([key, value]) => `${key}: ${value}; `)
      .join('');
    console.log(`%c${title}`, styleStr, info);
  }
};

export const bridgeCallLogger = (actionName: string, params: any = '') => {
  logger(`调用jsBridge::${actionName}`, '#ee8232', params);
};

export const bridgeCallbackLogger = (actionName: string, res: any = '') => {
  logger(`native调用callback::${actionName}`, '#ee8232', res);
};

export const haboClickLogger = (eventId: number, params: any = '') => {
  // logger(`habo 点击上报::${eventId}`, '#62bee8', params);
};

export const haboTimeEndLogger = (eventId: number, params: any = '') => {
  // logger(`habo 时长上报::${eventId}`, '#60c0d1', params);
};

export const dataLogger = (data: any) => {
  // logger('后端返回数据::', '#549f56', data);
};

export const fastLogger = (data: any, type: string) => {
  logger(`先返回的数据::${type}::`, '#549f56', data);
};

export const errorLogger = (data: any) => {
  logger('ERROR::', 'red', data);
};


export const perfLogger = () => {
  const fcp = Math.round(getFcp());
  const fmp = Math.round(getFmp());
  const style = {
    'font-size': '30px',
    'color': '#fefcd0',
    'background': '#39c5bb',
    'border-radius': '6px',
  };
  logger(`🚀fcp: ${fcp}ms\n🚀fmp: ${fmp}ms`, style);
};

export const importantLogger = (info: any) => {
  const style = {
    'font-size': '20px',
    'color': '#f00',
    'background': 'yellow',
    'border-right': '50vw solid yellow',
    'font-weight': 900
  };
  const text = typeof info === 'object' ? JSON.stringify(info, null, '\t') : info;
  logger(text, style);
  // logger(`fmp: ${fmp}ms`, style);
};

export default logger;
